module.exports = __webpack_public_path__ + "static/media/16.92f10aff.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/lhand/16.png
// module id = 756
// module chunks = 0